import { apiPesquisaSatisfacao, apiClientGeral } from '@/plugins/axios'

export default {
  gerarRelatorio(form) {
    return apiPesquisaSatisfacao().post('/satisfacao/relatorios/detalhado?_method=GET', form)
  },

  buscarChamadaPesquisa(linkedid) {
    return apiClientGeral().get(`/cdr/${linkedid}`)
  },

  getConferencias() {
    return apiClientGeral().get('/conferencias/lazy')
  },
}
